import React, { lazy, useEffect } from "react";
import HomeSeo from "./HomeSeo";
import HeroGallery from "./HeroGallery";
import About from "./About";
import Bag from "./Bag";
import Stat from "./Stat";
import Sponsors from "./Sponsors";
import Tournaments from "./Tournaments";
import HandicapTracker from "./HandicapTracker";
import NewsSlider from "./NewsSlider";

const Scores = lazy(() => import("./Scores"));

// Maps public URL slug -> DOM id of the section on the home page.
// Keep this in sync with the `navItems` list in `Navbar.js` and the
// `<url>` entries in `public/sitemap.xml`.
export const SECTION_IDS = {
  about: "about",
  equipment: "bag",
  sponsors: "sponsors",
  tournaments: "tournaments",
  stats: "stats",
};

export default function HomePage({ slug, scores }) {
  const sectionId = slug ? SECTION_IDS[slug] : null;

  useEffect(() => {
    if (!sectionId) {
      // Landing on "/" — make sure we start at the top.
      window.scrollTo({ top: 0, behavior: "auto" });
      return;
    }

    const scrollToSection = () => {
      const el = document.getElementById(sectionId);
      if (!el) return;
      const headerOffset = 80;
      const top =
        el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top, behavior: "smooth" });
    };

    // Scroll now, then retry once shortly after. The Contentful gallery and
    // lazy-loaded sections shift layout after initial paint, so the first
    // scroll position may not be final.
    scrollToSection();
    const retry = setTimeout(scrollToSection, 600);
    return () => clearTimeout(retry);
  }, [sectionId]);

  return (
    <>
      <HomeSeo slug={slug} />
      <HeroGallery />
      <div id="about">
        <About />
      </div>
      <div id="news">
        <NewsSlider />
      </div>
      <div id="bag">
        <Bag />
      </div>
      <div id="handicap">
        <HandicapTracker />
      </div>
      <div id="scores">
        <Scores scores={scores} />
      </div>
      <div id="sponsors">
        <Sponsors />
      </div>
      <div id="tournaments">
        <Tournaments />
      </div>
      <div id="stats">
        <Stat />
      </div>
    </>
  );
}
